import { _ } from "../polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import OldSpinnerWidget from "../../deprecated/OldSpinnerWidget/OldSpinnerWidget.js"; // eslint-disable-line import-x/no-deprecated -- todo: migrate to new spinner

let instance;

/**
 * Widget displayed during the initialization of the app.
 */
export default class ApplicationLoadingWidget extends Widget {
	constructor() {
		super(...arguments);

		// eslint-disable-next-line import-x/no-deprecated -- todo: migrate to new spinner
		this._spinner = new OldSpinnerWidget({
			dark: true,
			size: 64,
		});

		this._loadingQuotesTranslation = _(
			"Life is like accounting, everything must be balanced.\nAccounting is elegant and precise, not boring and ugly.\nAccounting is a story that must be told.\nIntelligible accounting makes the world a better place.\nAccounting is the diary of a business.\nWill you be an asset or a liability on the world's balance sheet?\nAccounting is the language of business.\nTogether we can make accounting great again!\nAccounting nerds should be celebrated like the superheroes they are.\nThere is no place for second rate accounting.\nWhy do economists exist? So accountants have someone to laugh at.\nWhat do accountants suffer from that ordinary people don’t? Depreciation.",
		);

		this._loadingQuotes = this._loadingQuotesTranslation
			.toString()
			.split("\n");
	}

	show() {
		this.appendTo("body");
		this._spinner.show();
	}

	setLogo(logo) {
		this._logo = logo;
	}

	hide() {
		this.asJQuery().fadeOut(300);
	}

	renderContentOn(html) {
		html.div(
			{ id: "application-loading", "data-test": "loading-company" },
			html.h2(
				html.img({ src: this._logo }),
				html.div(_("Loading company")),
			),
			this._spinner,
			html.div({ klass: "quote" }, this._getRandomLoadingQuote()),
		);
	}

	_getRandomLoadingQuote() {
		const randomIndex = Math.floor(
			// eslint-disable-next-line sonarjs/pseudo-random -- this is safe as we control the quotes
			Math.random() * this._loadingQuotes.length,
		);
		return this._loadingQuotes[randomIndex];
	}

	static instance() {
		instance ||= new this();

		return instance;
	}
}
